<template>
  <div id="home">
    <section id="main">
      <hero />
    </section>
  </div>
</template>

<script>
// import components
import hero from '@/views/home/Hero.vue';

// export view
export default {
  name: 'home',
  components: {
    hero,
  },
};
</script>
